module.exports = __webpack_public_path__ + "static/close-b4b8dda2332e02ef78b09e7d34f0f533.png";